/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $(".banner a").each(function(i, e){
          var $e = $(e);
          if($e.attr('href').match(/metri.ch[\/]?$/)){
            $e.attr('href', $e.attr('href')+'?intro=false');
          }
        });

        $(".carousel").swipe({
          swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
            if (direction === 'left'){ $(this).carousel("next"); } 
            if (direction === 'right'){ $(this).carousel("prev"); } 
          },
          allowPageScroll:"vertical"
        });

        $(".navbar-toggle").click(function(){
          $(".menu-overlay").fadeToggle(200);
          // $(this).toggleClass('btn-open').toggleClass('btn-close');
        });

        $(".close").click(function(){
          $(".menu-overlay").fadeToggle(200);
          // $(this).toggleClass('btn-open').toggleClass('btn-close');
        });

        $(document).ready(function() {
          //Grid
          var $grid = $('.mo1-grid');
          $grid.isotope({
            // options
            itemSelector: '.mo1-grid-item',
            layoutMode: 'fitRows'
          });
          window.$grid = $grid;

          // layout Isotope after all image has been loaded
          $grid.imagesLoaded().always( function() {
            setTimeout(function(params) {
              $grid.isotope('layout');
            }, 100)
          });

          //location
          var $filterLi = $('#mo1-projets .filters li');
          $filterLi.find('a').click(function(i,e){
            console.log('click');

            $filterLi.removeClass('active');

            var $e = $(this);
            $e.parent().addClass('active');
            var type = '.' + $e.attr('href').replace('#','');
            type = type === '.' ? '' : type ;
            console.log(type, 'isotope type');
            $grid.isotope({ filter: type });
          });

          $('#mo1-projets .filter .filter-item select').change(function(i, e){
            var $this = $(this);
            var val = $this.val();
            val  = (val === 'all') ? '' : '.' + val;
            $grid.isotope({ filter: val });
          });
        });

        //wpcf7
        $('.wpcf7-form').prepend($('div.wpcf7-response-output'));

        // Afficher tout
        $('#mo1-projets .filter .reset-filter').click(function(i,e){
          $grid.isotope({ filter: '' });
        });

        $(document).ready(function() {
            $('.filter-item select').select2();
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        setTimeout(function(){
          $('.home-overlay').hide();
        },4000);
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_tpl_contact': {
      init: function() {
        var map = null;
          jQuery(document).ready(function(){
              $('.gmap').each(function(){
                  // create map
                  map = new_map( $(this) );
                  window.gmap = map;
              });
          });
          console.log('contact js');

          // $('.wpcf7-form').prepend($('div.wpcf7-response-output'));
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
